import React from "react";
import { useTranslation } from "src/_common/hooks/useTranslation";

interface ProgressIndicatorProps {
  stage: "screening" | "talent-scouting" | "interview" | "final-decision" | "video-cv" | "candidates" | "no-video-cv" | "no-candidates";
  title?: string;
  description?: string;
  icon?: string;
}

const getStageConfig = (stage: ProgressIndicatorProps["stage"], t: any) => {
  switch (stage) {
    case "screening":
      return {
        title: t("jobDetails.progressIndicator.stages.screening.title"),
        description: t("jobDetails.progressIndicator.stages.screening.description"),
        icon: "fa-cogs",
        color: "#3b82f6",
      };
    case "talent-scouting":
      return {
        title: t("jobDetails.progressIndicator.stages.talentScouting.title"),
        description: t("jobDetails.progressIndicator.stages.talentScouting.description"),
        icon: "fa-search",
        color: "#8b5cf6",
      };
    case "interview":
      return {
        title: t("jobDetails.progressIndicator.stages.interview.title"),
        description: t("jobDetails.progressIndicator.stages.interview.description"),
        icon: "fa-users",
        color: "#059669",
      };
    case "final-decision":
      return {
        title: t("jobDetails.progressIndicator.stages.finalDecision.title"),
        description: t("jobDetails.progressIndicator.stages.finalDecision.description"),
        icon: "fa-check-circle",
        color: "#dc2626",
      };
    case "video-cv":
      return {
        title: t("jobDetails.progressIndicator.stages.videoCv.title"),
        description: t("jobDetails.progressIndicator.stages.videoCv.description"),
        icon: "fa-video",
        color: "#8b5cf6",
      };
    case "candidates":
      return {
        title: t("jobDetails.progressIndicator.stages.candidates.title"),
        description: t("jobDetails.progressIndicator.stages.candidates.description"),
        icon: "fa-users",
        color: "#059669",
      };
      case "no-candidates":
      return {
        title: t("jobDetails.progressIndicator.stages.noCandidates.title"),
        description: t("jobDetails.progressIndicator.stages.noCandidates.description"),
        icon: "fa-users",
        color: "#059669",
      };
      case "no-video-cv":
      return {
        title: t("jobDetails.progressIndicator.stages.noVideoCv.title"),
        description: t("jobDetails.progressIndicator.stages.noVideoCv.description"),
        icon: "fa-video",
        color: "#059669",
      };
    default:
      return {
        title: t("jobDetails.progressIndicator.stages.default.title"),
        description: t("jobDetails.progressIndicator.stages.default.description"),
        icon: "fa-cogs",
        color: "#3b82f6",
      };
  }
};

export default function ProgressIndicator({ stage, title, description, icon }: ProgressIndicatorProps) {
  const { t } = useTranslation("job-details");
  const stageConfig = getStageConfig(stage, t);

  const displayTitle = title || stageConfig.title;
  const displayDescription = description || stageConfig.description;
  const displayIcon = icon || stageConfig.icon;

  return (
    <div
      className="progress-indicator-wrapper"
      style={{
        textAlign: "center",
        padding: "80px 20px",
        backgroundColor: "#f8fafc",
        borderRadius: "12px",
        border: "2px dashed #cbd5e1",
        margin: "20px 0",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "20px",
        }}
      >
        <div
          style={{
            width: "80px",
            height: "80px",
            backgroundColor: stageConfig.color,
            borderRadius: "50%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <i className={`fa ${displayIcon}`} style={{ fontSize: "32px", color: "white" }}></i>
        </div>
        <div>
          <h2
            style={{
              fontSize: "24px",
              fontWeight: "600",
              color: "#1e293b",
              margin: "0 0 8px 0",
            }}
          >
            {displayTitle}
          </h2>
          <p
            style={{
              fontSize: "16px",
              color: "#64748b",
              margin: "0",
              lineHeight: "1.5",
            }}
          >
            {displayDescription}
            <br />
            {t("jobDetails.progressIndicator.checkBack")}
          </p>
        </div>
      </div>
    </div>
  );
}
